(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["forge-testimonials"] && !Shopify.designMode) return;
  try {
    
  function initForgeTestimonials(section) {
    const viewport = section.querySelector('[data-forge-testimonials-viewport]');
    const cards = Array.from(section.querySelectorAll('.forge-testimonials__card'));
    const dots = Array.from(section.querySelectorAll('[data-forge-testimonials-dot]'));
    const previous = section.querySelector('[data-forge-testimonials-previous]');
    const next = section.querySelector('[data-forge-testimonials-next]');

    if (!viewport || cards.length <= 3 || section.dataset.forgeTestimonialsReady === 'true') return;

    section.dataset.forgeTestimonialsReady = 'true';
    let currentPage = 0;

    const pageCount = Math.ceil(cards.length / 3);
    const setActiveDot = () => {
      dots.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === currentPage);
        dot.setAttribute('aria-current', index === currentPage ? 'true' : 'false');
      });
    };

    const scrollToPage = (page) => {
      currentPage = Math.max(0, Math.min(page, pageCount - 1));
      section.style.setProperty('--forge-testimonials-page', currentPage);
      setActiveDot();
    };

    previous?.addEventListener('click', () => scrollToPage(currentPage - 1));
    next?.addEventListener('click', () => scrollToPage(currentPage + 1));
    dots.forEach((dot) => {
      dot.addEventListener('click', () => scrollToPage(Number(dot.dataset.page || 0)));
    });

    setActiveDot();
  }

  function initAllForgeTestimonials() {
    document.querySelectorAll('.forge-testimonials').forEach(initForgeTestimonials);
  }

  initAllForgeTestimonials();
  document.addEventListener('shopify:section:load', initAllForgeTestimonials);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
